import { web as webRoute } from '@/support/route';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

interface AgentBreadcrumbProps {
  /** The trailing crumb — the current page/agent label shown after "In Vivo AI". */
  current: string;
}

/**
 * Breadcrumb for the AI agents area: a link back to the agents landing ("In Vivo AI") followed by the
 * current page label. Shared across the agent setup and session pages so they stay in lockstep.
 */
const AgentBreadcrumb: FC<AgentBreadcrumbProps> = ({ current }) => (
  <div className="f5 mb3" data-test-component="AgentBreadcrumb">
    <Link to={webRoute('agents')} className="blue link">
      In Vivo AI
    </Link>
    <span className="mh1 mid-gray">/</span>
    <span className="near-black" data-test-element="current">
      {current}
    </span>
  </div>
);

export default AgentBreadcrumb;
